import { List, ListItem, ListItemText, Switch } from '@mui/material';

// You will need to define a more accurate type for the Advisor
interface Advisor {
  AdvisorId: number;
  AdvisorName: string;
  IsAllowedToSee: boolean;
}

interface AdvisorPermissionsListProps {
  advisors: Advisor[];
  onAdvisorToggle: (advisorId: number) => void;
  isDisabled: boolean;
}

const AdvisorPermissionsListComponent = ({
  advisors,
  onAdvisorToggle,
  isDisabled,
}: AdvisorPermissionsListProps) => {
  return (
    <List>
      {advisors.map((advisor) => (
        <ListItem
          key={advisor.AdvisorId}
          secondaryAction={
            <Switch
              edge='end'
              checked={advisor.IsAllowedToSee}
              onChange={() => onAdvisorToggle(advisor.AdvisorId)}
              disabled={isDisabled}
            />
          }
        >
          <ListItemText primary={advisor.AdvisorName} />
        </ListItem>
      ))}
    </List>
  );
};

export default AdvisorPermissionsListComponent;
